import {
  ResponseDto,
  SurveyResponseDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const legacySurveyRequests = {
  getResponse: EndpointDefinition.get<SurveyResponseDto, { id: string }>({
    name: 'getSurveyResponse',
    route: '/surveys/responses/:id',
  }),
  getUserResponses: EndpointDefinition.get<ResponseDto[], { userId: string }>({
    name: 'getSurveyUserResponses',
    route: '/surveys/responses',
  }),
  postNewResponseAnswer: EndpointDefinition.post<
    ResponseDto,
    {
      responseId: string;
      questionId: string;
      optionId?: string;
      text?: string;
      date?: string;
      dateTime?: number;
    },
    null
  >({
    name: 'createSurveyAnswer',
    route: '/surveys/responses/answer',
  }),
  deleteResponseAnswer: EndpointDefinition.delete<
    ResponseDto,
    {
      optionId?: string;
      responseId: string;
      questionId: string;
    }
  >({
    name: 'deleteSurveyAnswer',
    route: '/surveys/responses/answer',
  }),
};
